import { Injectable } from '@angular/core';
import { AbstractRelatorioService } from '../abstract-relatorio.service';

@Injectable({
  providedIn: 'root'
})
export class RelatorioProcedimentoService extends AbstractRelatorioService {

  protected getBaseUrlPrivate(): string {
    return super.getBaseUrlPrivate() + 'exames';
  }

}
